import React, { useState, useEffect, useRef } from 'react';
import { compose } from 'redux';
import { withRouter, Link } from "react-router-dom";
import { pathOr } from 'ramda';
import { css } from 'emotion';
import { connect } from 'react-redux';
import { checkoutCredentials, redirectAfterLogout, redirectToLogin } from "../../../shared/utils";
import { logoutUser, pingUser, getRebookingTrips, getCovidLimitDateByAirline } from "../../../shared/requests-api";
import RebookingCard from './RebookingCard';
import MyAccountMenu from '../MyAccountMenu';
import * as cs from './styles';

function RebookingWrapper({ ordersToRebooking, history }) {
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(null);
  const [trips, setTrips] = useState([]);
  const [selectedId, setSelectedId] = useState(undefined);
  const cardRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    const _token = checkoutCredentials().au;
    setToken(_token);

    const queryString = history.location.search;
    const urlParams = new URLSearchParams(queryString);
    setSelectedId(urlParams.get('id'));

    const handleRebookingTrips = async () => {
      try {
        const covidJson = await getCovidLimitDateByAirline();

        if (pathOr(true, ['data', 'configuration', 'useDynamicRebooking'], covidJson)) {
          const rebookingTrips = await getRebookingTrips(_token);
          if (rebookingTrips.data.length > 0) {
            setTrips(rebookingTrips.data);
            setLoading(false);
          } else {
            history.push('/cliente/minhas-viagens-light');
          }
        } else {
          history.push('/cliente/minhas-viagens-light');
        }
      } catch (err) {
        history.push('/cliente/minhas-viagens-light');
      }
    }

    if (_token) {
      pingUser(_token)
        .then(response => {
          if (!response.data.success) {
            logoutUser()
              .then(() => {
                redirectAfterLogout(window);
              })
              .catch(error => {
                redirectToLogin(window);
                reject(error);
              });
          } else {
            if (ordersToRebooking) {
              setTrips(ordersToRebooking);
              setLoading(false);
            } else {
              handleRebookingTrips();
            }
          }
        })
        .catch(error => {
          redirectToLogin(window);
          reject(error);
        });
    } else {
      redirectToLogin(window);
    }
  }, []);

  useEffect(() => {
    if (!loading && selectedId && cardRef.current) {
      cardRef.current.scrollIntoView();
    }
  }, [loading, selectedId]);

  return (
    <div id="rebookingPage" className="tripspage container">
      <div className="row">
        <aside className="col-xs-16 col-md-4">
          <MyAccountMenu />
        </aside>

        <section className="col-xs-16 col-md-12">
          {loading && (
            <article className="new-card">
              <div className="new-card__content">
                <div className="loader-container">
                  <i className="loader loader-fetching center-block" />
                </div>
              </div>
            </article>
          )}

          {!loading && (
            <div className={css`${cs.rebookingWrapper}`}>
              <div className="return-row">
                <i className="icon icon-arrow-left return-icon"/>
                <Link
                  to="/cliente/minhas-viagens-light"
                  title="Voltar"
                  className="return-text"
                  data-action="my-trips-cancellation-page-return"
                >
                  Voltar
                </Link>
              </div>

              <h2>Viagens convertidas em crédito</h2>

              {trips.map((trip, index) => (
                trip.order.code === selectedId ? (
                  <RebookingCard ref={cardRef} isSelected trip={trip} token={token} key={`${trip.order.code}-${index}`} />
                ) : (
                  <RebookingCard trip={trip} token={token} key={`${trip.order.code}-${index}`} />
                )
              ))}
            </div>
          )}
        </section>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  ordersToRebooking: state.cancellation.ordersToRebooking
});

export default compose(
  withRouter,
  connect(mapStateToProps, {})
)(RebookingWrapper);